import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          console.error(
            `Network error on ${request.method} ${request.url}: ${error.message}`
          );
        } else {
          console.error(
            `HTTP ${error.status} on ${request.method} ${request.url}: ${error.message}`
          );
        }

        if (error.status === 401) {
          this.router.navigate(['/login']);
        }

        return throwError(() => error);
      })
    );
  }
}
